module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/8-992e2f0027fb6719f8d0ed66cd3825bc.jpg";